import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveRightIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4648 0.880238L15.4648 16.2324C15.4648 16.6563 15.8085 17 16.2325 17C16.6564 17 17.0001 16.6563 17.0001 16.2324L17.0001 0.880238C17.0001 0.456301 16.6564 0.112631 16.2325 0.112631C15.8085 0.112631 15.4648 0.456301 15.4648 0.880238Z" fill={props.fillColor ?? "#424C57"}/>
      <path d="M13.9296 10.8606L13.9296 6.25493C13.9296 5.61902 13.4141 5.10352 12.7782 5.10352L1.26404 5.10352C0.628132 5.10352 0.112627 5.61902 0.112627 6.25493L0.112627 10.8606C0.112627 11.4965 0.628132 12.012 1.26404 12.012L12.7782 12.012C13.4141 12.012 13.9296 11.4965 13.9296 10.8606Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>    
  )
}

export default MoveRightIcon;
